import { cloneDeep, set, update } from "lodash-es"
import dayjs from "dayjs"
import { useDispatch, useSelector } from "react-redux"
export const OPEN_DISPATCH_DRAWER = "OPEN_DISPATCH_DRAWER"
export const CLOSE_DISPATCH_DRAWER = "CLOSE_DISPATCH_DRAWER"

export const OPEN_DISPATCH_SUMMARY = "OPEN_DISPATCH_SUMMARY"
export const CLOSE_DISPATCH_SUMMARY = "CLOSE_DISPATCH_SUMMARY"
export const TOGGLE_DISPATCH_SUMMARY = "TOGGLE_DISPATCH_SUMMARY"

export const CHANGE_DISPATCH_VEHICLE = "CHANGE_DISPATCH_VEHICLE"

export const CHANGE_DISPATCH_SELECTOR = "CHANGE_DISPATCH_SELECTOR"

export const DISPATCH_SELECT_ORDER = "DISPATCH_SELECT_ORDER"

export const OPEN_ROUTE_PREVIEW = "OPEN_ROUTE_PREVIEW"
export const CLOSE_ROUTE_PREVIEW = "CLOSE_ROUTE_PREVIEW"

export const SORT_SELECTED_ORDERS = "SORT_SELECTED_ORDERS"
export const CHANGE_ORDER_SEQUENCE = "CHANGE_ORDER_SEQUENCE"

export const RESET_STATE = "RESET_STATE"

export const EDIT_TRIP_ORDERS = "EDIT_TRIP_ORDERS"

export const OPEN_DISPATCH_FILTER = "OPEN_DISPATCH_FILTER"
export const CLOSE_DISPATCH_FILTER = "CLOSE_DISPATCH_FILTER"

export const DISPATCH_CHANGE_ORDER_ITEM = "DISPATCH_CHANGE_ORDER_ITEM"

export const TOGGLE_ORDER_ITEM = "TOGGLE_ORDER_ITEM"
const INITIAL_STATE = {
  isOpen: false,
  isFilterOpen: false,
  isDispatchSummaryOpen: false,
  selectedOrders: new Map(),
  vehicle: null,
  isPreviewOpen: false,
  route: null,
  orderSequenceCustomized: false,
  date: dayjs().format("YYYY-MM-DD"),
  estimatedStartTime: new Date(),
  transportDetail: {
    acceptedDeduction: 0,
  },
}

function dispatchReducer(
  state = INITIAL_STATE,
  { type, payload, path, aggregator }
) {
  switch (type) {
    case OPEN_DISPATCH_FILTER:
      return {
        ...state,
        isOpen: false,
        isFilterOpen: true,
      }

    case CLOSE_DISPATCH_FILTER:
      return {
        ...state,
        isFilterOpen: false,
      }
    case OPEN_DISPATCH_DRAWER:
      return {
        ...state,
        isFilterOpen: false,
        isOpen: true,
      }
    case CLOSE_DISPATCH_DRAWER:
      return {
        ...state,
        isOpen: false,
      }
    case OPEN_DISPATCH_SUMMARY:
      return {
        ...state,
        isDispatchSummaryOpen: true,
      }

    case CLOSE_DISPATCH_SUMMARY:
      return {
        ...state,
        isDispatchSummaryOpen: false,
      }

    case TOGGLE_DISPATCH_SUMMARY:
      return {
        ...state,
        isDispatchSummaryOpen: !state.isDispatchSummaryOpen,
      }

    case CHANGE_DISPATCH_VEHICLE:
      return {
        ...state,
        vehicle: payload,
        // Only set the aggregator is we receive a valid value
        ...(aggregator && { aggregator }),
      }

    case CHANGE_DISPATCH_SELECTOR:
      const dispatchCopy = cloneDeep(state)
      set(dispatchCopy, path, payload)
      return dispatchCopy

    case DISPATCH_SELECT_ORDER:
      const selectedOrdersCopy = cloneDeep(state.selectedOrders)
      const ord = state.selectedOrders.get(payload.id)

      if (ord) {
        if (payload.orderStatus === "RFD") {
          selectedOrdersCopy.set(payload.id, {
            ...payload,
            isSelected: ord.isSelected === undefined ? false : !ord.isSelected,
            orderItems: ord?.orderItems?.map(i => ({
              ...i,
              isSelected: true,
            })),
          })
        } else {
          selectedOrdersCopy.delete(payload.id)
        }
      } else {
        selectedOrdersCopy.set(payload.id, {
          ...payload,
          orderItems: payload.orderItems?.map(i => {
            const qty = i?.quantity ?? 0
            const bQty = i?.bookedQuantity ?? 0

            return {
              ...i,
              newQuantity: i?.newQuantity ?? qty - bQty,
              isSelected: qty === bQty ? false : true,
            }
          }),
        })
      }
      return {
        ...state,
        selectedOrders: selectedOrdersCopy,
        isDispatchSummaryOpen: true,
        isPreviewOpen: false,
        isOpen: true,
      }

    case DISPATCH_CHANGE_ORDER_ITEM:
      const orderCpy = {
        ...state?.selectedOrders?.get(payload?.orderId),
      }
      set(
        orderCpy,
        `orderItems.${payload.itemIndex}.newQuantity`,
        payload.value
      )
      return {
        ...state,
        selectedOrders: state.selectedOrders.set(payload?.orderId, orderCpy),
      }
    case OPEN_ROUTE_PREVIEW:
      return {
        ...state,
        isPreviewOpen: true,
        route: payload,
      }

    case CLOSE_ROUTE_PREVIEW:
      return {
        ...state,
        isPreviewOpen: false,
      }
    case SORT_SELECTED_ORDERS:
      return {
        ...state,
        selectedOrders: payload instanceof Map ? payload : state.selectedOrders,
      }

    case TOGGLE_ORDER_ITEM:
      const ordCopy = cloneDeep(state.selectedOrders?.get(payload?.orderId))
      const itmIdx = ordCopy.orderItems?.indexOf(
        ordCopy.orderItems?.find(i => i.id === payload?.itemId)
      )
      update(ordCopy, `orderItems.${itmIdx}`, itm => ({
        ...itm,
        isSelected: itm?.isSelected ? false : true,
      }))
      return {
        ...state,
        selectedOrders: state.selectedOrders.set(payload?.orderId, ordCopy),
      }
    case CHANGE_ORDER_SEQUENCE:
      const mapArray = [...state.selectedOrders].map(([_, o]) => o)
      mapArray.splice(payload.oldIndex, 1)
      mapArray.splice(payload.newIndex, 0, payload.order)
      return {
        ...state,
        selectedOrders: mapArray.reduce(
          (prev, o) => prev.set(o?.id, o),
          new Map()
        ),
        orderSequenceCustomized: true,
      }

    case RESET_STATE:
      return {
        isOpen: false,
        isFilterOpen: false,
        isDispatchSummaryOpen: false,
        selectedOrders: new Map(),
        vehicle: null,
        isPreviewOpen: false,
        route: null,
        orderSequenceCustomized: false,
        date: dayjs().format("YYYY-MM-DD"),
        estimatedStartTime: new Date(),
        transportDetail: {
          acceptedDeduction: 0,
        },
      }

    case EDIT_TRIP_ORDERS:
      return {
        isOpen: true,
        isFilterOpen: false,
        isDispatchSummaryOpen: true,
        isPreviewOpen: false,
        orderSequenceCustomized: false,
        ...payload,
      }
    default:
      return state
  }
}

export function useSelectedOrder(payload) {
  const dispatch = useDispatch()
  const isSelected = useSelector((state: any) =>
    state.dispatch.selectedOrders?.get(payload?.id) ? true : false
  )

  function handleSelect() {
    dispatch({
      type: DISPATCH_SELECT_ORDER,
      payload,
    })
  }
  return [isSelected, handleSelect]
}

export function useTotalSelectedOrders() {
  const orders = useSelectedOrdersArray()
  return orders.reduce(
    (prev, item) => {
      if (item.isSelected === true || item.isSelected === undefined) {
        return {
          items:
            prev?.items + item?.orderItems?.filter(i => i?.isSelected)?.length,
          total: prev?.total + 1,
        }
      }
      return prev
    },
    { total: 0, items: 0 }
  )
  // return useSelector((state) => state.dispatch.selectedOrders.size);
}

export function useSelectedOrders() {
  return useSelector((state: any) => state.dispatch.selectedOrders)
}

export function useSelectedOrdersArray() {
  return useSelector((state: any) => {
    const ords = state.dispatch.selectedOrders
    return [...ords]
      .map(([_, value]) => value)
      .filter(o => {
        if (o.isSelected === false) return false
        return true
      })
  })
}

export function useTotalOrders() {
  return useSelector((state: any) => {
    const ords = state.dispatch.selectedOrders
    return [...ords].map(([_, value]) => value)
  })
}

export default dispatchReducer
